<template lang="pug">
  .grid-item
    .grid-block.img-block
      img(v-if="user.image" :src="user.image")
      img(v-else src="~@/assets/images/avatar.png")
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true },
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
